import { FC, useState } from 'react';
import { Button } from '../../components/Button';
import { useDriver } from '../../services/driver';
import { ConfirmAlert } from '../../components/AssignationModal/views';
import { logout } from '../Login/useLogin';
import styles from './Settings.module.css';
import { useLanguage, useLanguages } from '../../i18n';
import { DelayUnmount } from '../../components/DelayUnmount';
import { LanguageModal } from '../../components/LanguageModal';
import { FormattedMessage } from 'react-intl';
import { MenuBarButton } from '../../components/MenuBarButton';
import CustomiseIcon from '../../assets/icons/menu_customise.svg?react';
import LogoutIcon from '../../assets/icons/logout.svg?react';
import { Spacer } from '../../components/Spacer';
import clsx from 'clsx';
import { useMenuConfig, useMenuOptions } from '../../services/menu';

interface SettingsProps {}

export const Settings: FC<SettingsProps> = () => {
  const { result } = useDriver();
  const [confirm, setConfirm] = useState(false);
  const [isOpen, setOpen] = useState(false);
  const language = useLanguage();
  const languages = useLanguages();

  const config = useMenuConfig();
  const options = useMenuOptions();

  return (
    <>
      <div className={styles.root}>
        <div>
          <div className={styles.heading}>
            <FormattedMessage id="Driver" />
          </div>
          <div>
            {`${result?.firstName ?? ''} ${result?.lastName ?? ''}`.trim()}
          </div>
        </div>

        <div>
          <div className={styles.heading}>
            <FormattedMessage id="Language" />
          </div>
          <Button
            variant="text"
            className={styles.btn}
            compact
            onClick={() => setOpen(true)}
          >
            {languages.find(({ code }) => code === language)?.language}
          </Button>
        </div>

        <div className={styles.separator} />
        <div className={styles.menu}>
          <MenuBarButton
            className={styles.menuItem}
            inline
            to="/customise"
            icon={<CustomiseIcon />}
          >
            <FormattedMessage id="CustomiseMenu" />
          </MenuBarButton>
          {options
            .filter(({ id }) => !config.includes(id))
            .map(({ id, to, icon, name }) => (
              <MenuBarButton
                key={id}
                className={styles.menuItem}
                inline
                to={to}
                icon={icon}
              >
                <FormattedMessage id={name} />
              </MenuBarButton>
            ))}
        </div>
        <Spacer />
        <div>
          <Button
            variant="text"
            className={clsx(styles.btn, styles.logoutBtn)}
            compact
            onClick={() => setConfirm(true)}
          >
            <LogoutIcon className={styles.logoutIcon} />
            <FormattedMessage id="Logout" />
          </Button>
        </div>
      </div>

      {confirm && (
        <ConfirmAlert open onClose={() => setConfirm(false)} onConfirm={logout}>
          <FormattedMessage tagName="p" id="Logout.Confirm" />
        </ConfirmAlert>
      )}
      <DelayUnmount unmount={!isOpen}>
        <LanguageModal open={isOpen} onClose={() => setOpen(false)} />
      </DelayUnmount>
    </>
  );
};
